import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
} from '@mui/material'
import CustomInput from '../../../../../components/muiComponents/customInput/CustomInput'
import {
    calculateNumberFromPercentage,
    capitalize,
} from '../../../../../utils/functions'
import { CoursePriceState, PriceState } from '../../../../../features/types'
import {
    center,
    exitPriceBox,
    exitPriceTitle,
    flexBetween,
    promocodeButton,
    summaryCardBox,
} from '../style'
import { SelectedSubjectState } from '../types'

interface Props {
    selectedSubjects: SelectedSubjectState[]
    price: PriceState
    coursePrice: CoursePriceState
    isLoading?: boolean
}

const SummaryCard: React.FC<Props> = ({
    selectedSubjects,
    price,
    coursePrice,
    isLoading,
}) => {
    const purchasePrice = price ?? {
        totalPrice: 0,
        purchasePrice: 0,
        discountPrice: 0,
    }
    const { formatMessage, locale } = useIntl()
    const [promoCode, setPromoCode] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)

    const filteredSubjects = selectedSubjects.filter(
        (subject) => subject.isSelected || subject.selectedTopics.length,
    )

    const getPrice = (subject: SelectedSubjectState): number => {
        if (subject.isSelected) {
            return subject.courseSubjectPrice.discountPrice
        }

        if (subject.selectedTopics.length) {
            return (
                calculateNumberFromPercentage(
                    subject.courseSubjectPrice.singleTopicPrice,
                    subject.courseSubjectPrice.discount,
                ) * subject.selectedTopics.length
            )
        }
    }

    return (
        <Box sx={summaryCardBox}>
            <Box sx={exitPriceBox}>
                <Box sx={exitPriceTitle}>
                    {formatMessage({ id: 'exitPrice' })}
                </Box>

                {isLoading && (
                    <Box sx={center}>
                        <CircularProgress style={{ textAlign: 'center' }} />
                    </Box>
                )}

                <Box sx={flexBetween}>
                    <Box sx={{ fontWeight: 500 }}>
                        {formatMessage({ id: 'course' })}
                    </Box>

                    <Box>{coursePrice[`title${capitalize(locale)}`]}</Box>
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Box sx={flexBetween}>
                    <Box sx={{ fontWeight: 500 }}>
                        {formatMessage({ id: 'subject' })}
                    </Box>

                    <Box>{formatMessage({ id: 'price' })}</Box>
                </Box>

                {filteredSubjects.map((subject) => (
                    <Box
                        key={subject.id}
                        sx={flexBetween}
                    >
                        <Box>{subject[`title${capitalize(locale)}`]}</Box>

                        <Box>{getPrice(subject)} т</Box>
                    </Box>
                ))}

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Box sx={flexBetween}>
                    <Box sx={{ fontWeight: 500 }}>
                        {formatMessage({ id: 'totalPrice' })}
                    </Box>

                    <Box sx={{ textDecoration: 'line-through' }}>
                        {filteredSubjects.length && purchasePrice.totalPrice} т
                    </Box>
                </Box>

                <Box sx={flexBetween}>
                    <Box sx={{ fontWeight: 500 }}>
                        {formatMessage({ id: 'withPackageDiscount' })}
                    </Box>

                    <Box>
                        {filteredSubjects.length && purchasePrice.discountPrice}{' '}
                        т
                    </Box>
                </Box>

                {/* {promoCode ? (
                    <Box sx={flexBetween}>
                        <Box sx={{ fontWeight: 500 }}>Промокод</Box>
                        <Box>NFDLNxDFL</Box>
                    </Box>
                ) : (
                    <Button
                        sx={promocodeButton}
                        onClick={() => setOpenDialog(true)}
                    >
                        Менде промокод бар
                    </Button>
                )} */}

                <Box sx={flexBetween}>
                    <Box sx={{ fontWeight: 500 }}>
                        {formatMessage({ id: 'amountOfPayment' })}
                    </Box>
                    <Box>
                        {filteredSubjects.length && purchasePrice.discountPrice}{' '}
                        т
                    </Box>
                </Box>
            </Box>

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Промокод енгизу</DialogTitle>

                <DialogContent>
                    <CustomInput
                        placeholder="Промокод енгизу"
                        fullWidth
                    />
                </DialogContent>

                <DialogActions style={{ padding: '0 24px 12px 0' }}>
                    <Button onClick={() => setOpenDialog(false)}>
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button variant="contained">
                        {formatMessage({ id: 'submit' })}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default SummaryCard
